<template>
  <div class="container-fluid">
    <div class="row">
      <div class="form-group col-md-2">
        <label class="labelTitle">Select current extensions</label>
      </div>
    </div>
    <div class="d-flex">
      <div v-for="(template, index) in templates">
        <BaseImage
          class="mr-2"
          style="width: 300px"
          :key="index"
          :image="template.url"
        />
        <div style="display: flex; flex-direction: column; align-items: center">
          <div
            class="colCheckboxRequest form-group col col-6 col-md-4 text-center"
            style="margin-bottom: 10px !important;"
          >
            <label class="kt-checkbox kt-checkbox--bold">
              <input
                type="checkbox"
                v-model="template.active"
              />
              <span></span>
            </label>
          </div>
          <div>{{ template.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from "@/components/_shared/accordion/Accordion.vue";
import AccordionCard from "@/components/_shared/accordion/AccordionCard.vue";
import BaseImage from "@/components/_base/BaseImage.vue";
import ExtensionSelectorModal from "@/components/opportunity-edit/ExtensionSelectorModal.vue";

export default {
  name: "TabExtensionTemplateSelect",
  components: {ExtensionSelectorModal, BaseImage, AccordionCard, Accordion},
  data () {
    return {
      showModal: false,
      isCompleting: false,
    }
  },
  props: {
    templates: {
      type: Array,
      default: [],
    },
  }
}
</script>

<style scoped>

</style>
